import {
    ACTION_SET_BOOK_NAME

} from './action'


export default {
    //拆解的单词信息
    book_name(state = '', action) {
        const { type, payload } = action;
        switch (type) {
            case ACTION_SET_BOOK_NAME:
                return payload
        }
        return state;
    }

}